export const environment = {
  production: false,
  envName: 'dev',
  getSsoToken: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/get-sso-token',

  /**** b2c app start here  ****/
  userPoolId: 'ap-south-1_7frXnSuBj',
  domain: 'uat-b2c-sso.auth.ap-south-1.amazoncognito.com',

  /*Not Used */
  insurance_clientid: '5uomtka964en0m78mbij1n5uk',
  redirectUrlinsurance: 'https://prod-insurance-test-b2c.bajajcapitalinsurance.com/processback.aspx',
  Insurance_redirectSignIn_url: 'https://sso.bajajcapital.com/callback?clientId=5uomtka964en0m78mbij1n5uk',
  Insurance_redirectSignOut_url: 'https://sso.bajajcapital.com/sign-out?clientId=5uomtka964en0m78mbij1n5uk',

  mf_clientid: '53tns3lrtn8hrvm27jb4rpnhii',
  redirectUrlmf: 'https://uatonlinemf.bajajcapital.com/home.aspx',
  MF_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=53tns3lrtn8hrvm27jb4rpnhii',
  MF_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=53tns3lrtn8hrvm27jb4rpnhii',

  nps_subdomain_clientid: '1c7qp8o8b9ngr3k60bn3ff0o80',
  redirectUrlnps_subdomain: 'https://devnps.bajajcapital.com/callback',
  NPS_subdomain_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=1c7qp8o8b9ngr3k60bn3ff0o80',
  NPS_subdomain_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=1c7qp8o8b9ngr3k60bn3ff0o80',

  b2c_insurance_clientid: '3uil6afjlk64adjg3vm582sbm3',
  redirectionurl_b2c_insurance: 'https://dev.bajajcapitalinsurance.com/ProcessBack',
  b2cinsurance_redirectionsignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=3uil6afjlk64adjg3vm582sbm3',
  b2cinsurance_redirectionsignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=3uil6afjlk64adjg3vm582sbm3',

  b2c_india_bonds: '6om9ken1l0s0koj1skqp7r6e4h',
  redirectionurl_b2c_indiabonds: 'https://dev-bonds.bajajcapital.com/callback',
  b2c_india_bonds_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=6om9ken1l0s0koj1skqp7r6e4h',
  b2c_india_bonds_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=6om9ken1l0s0koj1skqp7r6e4h',

  unifieddashboard: '2ucoolk893144vnsm88muuttft',
  unifieddashboard_redirection: 'https://uatmydashboard.bajajcapital.com/callback',
  unifieddashboard_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=2ucoolk893144vnsm88muuttft',
  unifieddashboard_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=2ucoolk893144vnsm88muuttft',

  unifieddashboardcopy: '3rd1oh19lgsqjm6rklps1or5vn',
  unifieddashboardcopy_redirection: 'https://uatmydashboard-v2.bajajcapital.com/callback',
  unifieddashboardcopy_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=3rd1oh19lgsqjm6rklps1or5vn',
  unifieddashboardcopy_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=3rd1oh19lgsqjm6rklps1or5vn',

  fpb2c_clientid: '3mrfqoguqo3964n9jaaf1jv1fu',
  fpc_redirection: 'https://devfp.bajajcapital.com/auth/callback',
  fpc_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=3mrfqoguqo3964n9jaaf1jv1fu',
  fpc_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=3mrfqoguqo3964n9jaaf1jv1fu',

  bcml_insurance: '6j60su9fb9vlbkurr59usok6gp',
  bcml_insurance_redirection: 'https://dev-insurance.bajajcapital.com/callback',
  bcml_insurance_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=6j60su9fb9vlbkurr59usok6gp',
  bcml_insurance_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=6j60su9fb9vlbkurr59usok6gp',

  sendOtpUrl: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/send-otp',
  verifyOtpUrl: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/verify-otp',
  usercheck: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/user-check',
  checkssouserStatus: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/check-userStatus',
  updateuserstatus: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/update-userStatus',
  b2ccheckemailexist: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/check-email-exists',
  b2cunifiedUserCheck: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/userIdentityValidation',
  b2cpasswordreset: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/resetPassword',
  b2cinserapi: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/insertEmail',
  /**** b2c app End here  ****/


  /**** b2b app start here  ****/
  b2b_user_Pool: 'ap-south-1_sjCBqO37e',
  b2b_domain: 'uat-b2b-sso.auth.ap-south-1.amazoncognito.com',

  b2b_insurance: '6nbjrnetj6sc7jrcaoi4b4bshl',
  redirectUrlB2BINS: 'https://partneruat.bajajcapitalinsurance.com/ProcessBack',
  b2b_insurance_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=6nbjrnetj6sc7jrcaoi4b4bshl',
  b2b_insurance_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=6nbjrnetj6sc7jrcaoi4b4bshl',

  retirment_clientid: '1m4q7vd0fqj15sbosh5huhuq99',
  retirment_url: 'https://devprp.bajajcapital.com/',
  prp_retirment_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=1m4q7vd0fqj15sbosh5huhuq99',
  prp_retirment_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=1m4q7vd0fqj15sbosh5huhuq99',

  surveypro_clientid: '5ehc8gt6jvihrkhph8p5s36nls',
  surveypro_url: 'https://dev-surveypro.bajajcapitalone.com/#/callback',
  surveypro_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=5ehc8gt6jvihrkhph8p5s36nls',
  surveypro_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=5ehc8gt6jvihrkhph8p5s36nls',

  bqdashboard_clientid: '1j1r1ptv2g5ugs91ra7a9j1ne4',
  bqdashboard_url: 'http://uatinsights.bajajcapital.com/api/auth/authenticate/callback',
  bqdashboard_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=1j1r1ptv2g5ugs91ra7a9j1ne4',
  bqdashboard_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=1j1r1ptv2g5ugs91ra7a9j1ne4',

  post_retirement_clientid: '1obpv3oa51gelkovhqhgmi4gqd',
  post_retirement_url: 'https://devrp.bajajcapital.com/#/login',
  postretirement_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=1obpv3oa51gelkovhqhgmi4gqd',
  postretirement_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=1obpv3oa51gelkovhqhgmi4gqd',

  b2b_india_bonds_clientid: '2jv3pn6t8674psh21in45mdhga',
  b2b_indiabonds_url: 'https://dev-bonds.bajajcapital.com/callback',
  b2bindiabonds_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=2jv3pn6t8674psh21in45mdhga',
  b2bindiabonds_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=2jv3pn6t8674psh21in45mdhga',

  DatacloudWM_clientid: '1kttrfc0ie7b9f6m48e1kjinb2',
  DatacloudWM_url: 'https://datacloud.bajajcapital.com/callback',
  DatacloudWM_redirectSignIn_url: 'http://datacloud.bajajcapital.com/callback?clientId=1kttrfc0ie7b9f6m48e1kjinb2',
  DatacloudWM_redirectSignOut_url: 'http://datacloud.bajajcapital.com/sign-out?clientId=1kttrfc0ie7b9f6m48e1kjinb2',

  fpb2b_clientid: '2m0d3tetpq1c9sasfdvlh2dl4m',
  fp_url: 'https://devfp.bajajcapital.com/auth/callback',
  fp_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=2m0d3tetpq1c9sasfdvlh2dl4m',
  fp_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=2m0d3tetpq1c9sasfdvlh2dl4m',

  digitalrm_clientid: '2rr498hhno0m1s277kban6adob',
  digitalrm_url: 'https://uatgreetings.bajajcapital.com/',
  digitalrm_redirectSignIn_url: 'https://uat-sso.bajajcapital.com/callback?clientId=2rr498hhno0m1s277kban6adob',
  digitalrm_redirectSignOut_url: 'https://uat-sso.bajajcapital.com/sign-out?clientId=2rr498hhno0m1s277kban6adob',

  rmstatus: 'https://ihfft8ixpd.execute-api.ap-south-1.amazonaws.com/b2b/uat/check-rm-details',
  activeuser: 'https://ihfft8ixpd.execute-api.ap-south-1.amazonaws.com/b2b/uat/active-user',
  b2buserstatus: 'https://ihfft8ixpd.execute-api.ap-south-1.amazonaws.com/b2b/uat/check-userStatus',
  b2buserstatusupdate: 'https://ihfft8ixpd.execute-api.ap-south-1.amazonaws.com/b2b/uat/update-userStatus',
  b2b_usercheck: 'https://ihfft8ixpd.execute-api.ap-south-1.amazonaws.com/b2b/uat/sso-user-check',
  userhistory: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/audit-log',
  b2bcheckmobileexist: 'https://ihfft8ixpd.execute-api.ap-south-1.amazonaws.com/b2b/uat/check-mobile-exists',
  b2bresetpassword: 'https://ihfft8ixpd.execute-api.ap-south-1.amazonaws.com/b2b/uat/resetPassword',
  loginattempt: 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso/check-login-attempts',
  unifiedUserCheck: 'https://ihfft8ixpd.execute-api.ap-south-1.amazonaws.com/b2b/uat/userIdentityValidation',

  /**** b2b app End here  ****/

};
